import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
    status: number;
    message: string;
    statusCode: number;
}

export const BudgetCategoryApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getBudgetCategory: builder.query<
            CommonResponseType & { data: any },
            {
                search?: string;
                start?: number;
                length?: number;
            }
        >({
            query: ({ search, start, length } = {}) => ({
                url: `${END_POINTS.budgetCategory}?start=${start}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
                method: "GET",
            }),
        }),
        addBudgetCategory: builder.mutation<
            CommonResponseType & { data: any },
            { body: CommonBody }
        >({
            query: ({ body }) => ({
                url: END_POINTS.addBudgetCategory,
                method: "POST",
                body,
            }),
        }),

 updateBudgetCategory: builder.mutation<CommonResponseType, { body: any; id: number }>(
      {
        query: ({ body, id }) => ({
          url: `${END_POINTS.updateBugde}${id}/`,
          method: "PUT",
          body,
        }),
      }
    ),
      getBudgeById: builder.query<
          CommonResponseType & { data: any },
          {
            id: number;
          }
        >({
          query: ({ id }) => ({
            url: `${END_POINTS.getByIdBugde}${id}/`,
            method: "GET",
          }),
        }),
     deleteBudge: builder.mutation<CommonResponseType, { id: number }>({
          query: ({ id }) => ({
            url: `${END_POINTS.deleteBugde}${id}/`,
            method: "DELETE",
          }),
        }),
    }),
});

export const {
    useLazyGetBudgetCategoryQuery,
    useLazyGetBudgeByIdQuery,
    useAddBudgetCategoryMutation,
    useDeleteBudgeMutation,
    useUpdateBudgetCategoryMutation
} = BudgetCategoryApi;
